const helperConstants = {
  industry: "industries",
  country: "country",
  paymentMethod: "affiliate_payment_method",
  mediaLanguage: "media_language",
};

export default helperConstants;
